<template>
  <div>
    <title-bar :title-stack="['Measurement Data Download']" />
    <section class="section is-main-section">
      <tiles>
        <div>
         <b-field label="Which Train">
          <b-select v-model="train" placeholder="Select a train">
            <option
                v-for="option in trainOptions"
                :value="option"
                :key="option">
                {{ option }}
            </option>
          </b-select>
        </b-field>
          <b-field label="Which Location">
            <b-select v-model="location" placeholder="Select a location">
              <option
                  v-for="option in locationOptions"
                  :value="option"
                  :key="option">
                  {{ option }}
              </option>
            </b-select>
        </b-field>
        <b-field label="Select a date">
          <b-datepicker
              v-model="measureDate"
              placeholder="Select the date ..."
              icon="calendar-today">
          </b-datepicker>
        </b-field>
          <b-field grouped group-multiline>
            <b-field label="Start Time">
              <b-clockpicker
                v-model="startTime"
                :editable="true"
                placeholder="Click to select..."
                icon="clock"
                :enable-seconds="true"
                hour-format="24">
              </b-clockpicker>
            </b-field>
            <b-field label="End Time">
              <b-clockpicker
                v-model="endTime"
                :editable="true"
                placeholder="Click to select..."
                icon="clock"
                :enable-seconds="true"
                hour-format="24">
              </b-clockpicker>
            </b-field>
          </b-field>
          <section class="section">
            <div class="buttons">
              <b-button @click="downloadItem" type="is-primary" icon-left="download">
                  Download
              </b-button>
          </div>
          </section>

        </div>
        <div style="width: 100%; min-height: 50em">
           <Map :device="locationDevice" :timeRange="[startTime, endTime]"></Map>
           <div></div>
        </div>
      </tiles>
    </section>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar'
import Tiles from '@/components/Tiles'
import Map from '@/components/TN-Map'
import { api } from '@/main.js'

let options = {
  ABDeh2026: 'c44f332230e9',
  BDSeh2052: 'c45bbe300c5c'
}

export default {
  name: 'download',
  components: {
    TitleBar,
    Tiles,
    Map
  },
  data: () => {
    return {
      trainOptions: ['ABDeh2026', 'BDSeh2052'],
      locationOptions: ['Wagenkasten', 'Drehgestell', 'Radsatzlager links', 'Radsatzlager rechts'],
      train: 'ABDeh2026',
      location: 'Wagenkasten',
      measureDate: new Date(),
      startTime: new Date(),
      endTime: new Date(),
      locationDevice: options['ABDeh2026']

    }
  },
  methods: {
    downloadItem () {
      api.get(`/download?train=${this.train}&location=${this.location}&start=${this.startTime.getTime()}&end=${this.endTime.getTime()}`, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${this.train}-${this.location}_${this.startTime.toLocaleString()}-${this.endTime.toLocaleString()}.csv`
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)
    }
  },
  watch: {
    measureDate () {
      this.startTime.setDate(this.measureDate.getDate())
      this.endTime.setDate(this.measureDate.getDate())
    },
    train () {
      this.locationDevice = options[this.train]
    }
  }
}
</script>

<style scoped>

</style>
